<template>
  <section class="panel-section">
    <h5 v-if="title" class="panel-section__title">{{ title }}<metric-info-tooltip v-if="help" :content="help" /></h5>
    <slot />
  </section>
</template>

<script>
import MetricInfoTooltip from '@/components/Levels/MetricInfoTooltip'

export default {
  name: 'PanelSection',
  components: {
    MetricInfoTooltip
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    help: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.panel-section {
  padding: 16px 0;
  border-bottom: 1px solid var(--line);
}

.panel-section:last-of-type {
  border-bottom: 0;
}

.panel-section__title {
  margin-bottom: 8px;
  font-size: var(--font-small);
  font-weight: 600;
  color: var(--text-body);
  text-transform: none;
  letter-spacing: normal;
}
</style>
